/* Sections: #app (1), #cards (5), #media (5), #updates (9) */

const cards = [
  {
    id: 1,
    title: '2024 年度高分电影盘点',
    desc: '从科幻到文艺，这一年不容错过的高清电影都在这里了。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20with%20warm%20golden%20lighting%2C%20film%20strip%20border%20decoration%2C%20classic%20theater%20red%20curtains%20at%20edges%2C%20soft%20spotlight%20effect%2C%20elegant%20minimal%20composition%2C%20dark%20background%20with%20amber%20accents%2C%20sophisticated%20cinema%20theme%2C%20no%20text%20no%20people&width=800&height=500&seq=card-movie-01&orientation=landscape',
    tag: '精选合集',
  },
  {
    id: 2,
    title: '暑期追剧指南：十部必看热剧',
    desc: '从悬疑到甜宠，暑期档高清电视剧免费看全攻略。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20dramatic%20television%20series%20theme%20composition%20with%20soft%20golden%20hour%20lighting%2C%20vintage%20TV%20set%20silhouette%2C%20cozy%20living%20room%20atmosphere%2C%20film%20noir%20inspired%20shadows%2C%20rich%20amber%20and%20crimson%20tones%2C%20elegant%20minimal%20design%2C%20no%20text%20no%20people&width=800&height=500&seq=card-tv-02&orientation=landscape',
    tag: '追剧攻略',
  },
  {
    id: 3,
    title: '经典港片修复版合集上线',
    desc: '高清修复的经典港片，重温黄金年代的银幕记忆。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20cinema%20aesthetic%20with%20neon%20light%20reflections%2C%20classic%20film%20poster%20textures%2C%20warm%20nostalgic%20amber%20tones%2C%20old%20movie%20theater%20marquee%20with%20soft%20glow%2C%20retro%20cinematic%20atmosphere%2C%20elegant%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=card-hk-03&orientation=landscape',
    tag: '经典重温',
  },
  {
    id: 4,
    title: '国产动漫崛起：必看国漫推荐',
    desc: '画质精美剧情在线，这些国产动漫值得你熬夜追完。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20abstract%20composition%20with%20warm%20sunset%20colors%2C%20flowing%20ink%20wash%20effects%2C%20traditional%20Chinese%20painting%20elements%20blended%20with%20modern%20cinema%2C%20soft%20gradient%20lighting%2C%20elegant%20oriental%20aesthetic%2C%20dreamy%20atmosphere%2C%20no%20text%20no%20people&width=800&height=500&seq=card-anime-04&orientation=landscape',
    tag: '国漫精选',
  },
  {
    id: 5,
    title: '周末观影：冷门佳作挖掘计划',
    desc: '那些被埋没的好电影，部部都是值得细细品味的佳作。',
    img: 'https://readdy.ai/api/search-image?query=Independent%20cinema%20aesthetic%20with%20soft%20natural%20window%20light%2C%20minimal%20wooden%20interior%2C%20film%20projector%20casting%20warm%20light%20on%20blank%20wall%2C%20cozy%20arthouse%20theater%20vibe%2C%20golden%20amber%20tones%2C%20contemplative%20atmosphere%2C%20no%20text%20no%20people&width=800&height=500&seq=card-indie-05&orientation=landscape',
    tag: '冷门佳片',
  },
];

const mediaItems = [
  {
    id: 1,
    title: '星际穿越：穿越时空的父爱',
    type: '科幻 / 剧情',
    dur: '2h 49min',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20with%20dramatic%20lighting%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20film%20grain%20texture%2C%20elegant%20minimal%20composition%2C%20dark%20theater%20background%2C%20professional%20cinematography%20aesthetic%2C%20no%20text%20no%20people&width=600&height=900&seq=media-scifi-01&orientation=portrait',
  },
  {
    id: 2,
    title: '漫长的季节：东北往事',
    type: '悬疑 / 生活',
    dur: '12集全',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20with%20dramatic%20lighting%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20film%20grain%20texture%2C%20elegant%20minimal%20composition%2C%20dark%20theater%20background%2C%20professional%20cinematography%20aesthetic%2C%20no%20text%20no%20people&width=600&height=900&seq=media-drama-02&orientation=portrait',
  },
  {
    id: 3,
    title: '奥本海默：原子弹之父',
    type: '传记 / 历史',
    dur: '3h 00min',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20with%20dramatic%20lighting%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20film%20grain%20texture%2C%20elegant%20minimal%20composition%2C%20dark%20theater%20background%2C%20professional%20cinematography%20aesthetic%2C%20no%20text%20no%20people&width=600&height=900&seq=media-bio-03&orientation=portrait',
  },
  {
    id: 4,
    title: '莲花楼：江湖探案传奇',
    type: '古装 / 武侠',
    dur: '40集全',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20with%20dramatic%20lighting%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20film%20grain%20texture%2C%20elegant%20minimal%20composition%2C%20dark%20theater%20background%2C%20professional%20cinematography%20aesthetic%2C%20no%20text%20no%20people&width=600&height=900&seq=media-wuxia-04&orientation=portrait',
  },
  {
    id: 5,
    title: '哈尔的移动城堡',
    type: '动画 / 奇幻',
    dur: '1h 59min',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20with%20dramatic%20lighting%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20film%20grain%20texture%2C%20elegant%20minimal%20composition%2C%20dark%20theater%20background%2C%20professional%20cinematography%20aesthetic%2C%20no%20text%20no%20people&width=600&height=900&seq=media-anime-05&orientation=portrait',
  },
];

const updates = [
  { id: 1, date: '07-31', title: '《流浪地球3》高清版独家上线', tag: '新片速递', tagColor: 'bg-accent-500' },
  { id: 2, date: '07-30', title: '暑期档专题"科幻大片合集"更新至第8期', tag: '专题更新', tagColor: 'bg-primary-500' },
  { id: 3, date: '07-29', title: '平台片库突破12万部，高清电影持续入库', tag: '平台动态', tagColor: 'bg-secondary-500' },
  { id: 4, date: '07-28', title: '《繁花》沪语版全集上线，原汁原味呈现', tag: '热剧更新', tagColor: 'bg-accent-400' },
  { id: 5, date: '07-27', title: '播放器升级完成，4K画质观影更流畅', tag: '功能升级', tagColor: 'bg-primary-400' },
  { id: 6, date: '07-26', title: '《封神第二部》院线热映同步解读专题上线', tag: '专题上新', tagColor: 'bg-secondary-400' },
  { id: 7, date: '07-25', title: '纪录片频道新增BBC自然系列20部', tag: '片库更新', tagColor: 'bg-accent-300' },
  { id: 8, date: '07-24', title: '日韩剧场分类优化，找剧更方便', tag: '体验优化', tagColor: 'bg-primary-300' },
  { id: 9, date: '07-23', title: '经典老片修复计划第3批片单公布', tag: '项目进展', tagColor: 'bg-secondary-300' },
];

export default function SectionsPart2() {
  return (
    <>
      {/* #app */}
      <section id="app" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                移动观影
              </h2>
              <p className="text-sm text-foreground-500 mb-2 max-w-md mx-auto lg:mx-0">
                随时随地，高清在线观看免费电影电视剧
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                久久影视移动端完美适配手机与平板，通勤路上、午休时间、睡前放松，
                打开浏览器即可畅享高清影视在线体验。无需下载安装，1080P 画质自动适配，
                流量消耗更低，观影更自由。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 bg-background-50 rounded-full px-4 py-2">
                  <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                  <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">手机浏览器直达</span>
                </div>
                <div className="flex items-center gap-2 bg-background-50 rounded-full px-4 py-2">
                  <i className="ri-tablet-line text-primary-500 text-lg"></i>
                  <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">平板完美适配</span>
                </div>
                <div className="flex items-center gap-2 bg-background-50 rounded-full px-4 py-2">
                  <i className="ri-wifi-line text-primary-500 text-lg"></i>
                  <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">省流量模式</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="relative w-[220px] h-[440px] sm:w-[260px] sm:h-[520px] rounded-3xl overflow-hidden shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20smartphone%20mockup%20displaying%20cinema%20streaming%20interface%20with%20dark%20theme%2C%20movie%20poster%20thumbnails%20in%20grid%20layout%2C%20warm%20amber%20accent%20colors%2C%20minimal%20UI%20design%2C%20floating%20phone%20on%20soft%20gradient%20background%2C%20sophisticated%20app%20presentation%2C%20clean%20modern%20aesthetic%2C%20no%20text&width=520&height=1040&seq=app-mobile-jiujiu&orientation=portrait"
                  alt="久久影视移动端观影体验"
                  className="w-full h-full object-cover"
                  onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* #cards */}
      <section id="cards" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 max-w-md mx-auto">
            编辑精选的高清电影与高清电视剧内容合集，发现更多好片
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.slice(0, 3).map((item) => (
              <div
                key={item.id}
                className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:shadow-md transition-all duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="text-[10px] px-2 py-1 rounded-full bg-background-950/70 text-background-50 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
            {cards.slice(3, 5).map((item) => (
              <div
                key={item.id}
                className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:shadow-md transition-all duration-300 flex flex-col sm:flex-row"
              >
                <div className="relative h-40 sm:h-auto sm:w-48 flex-shrink-0 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="text-[10px] px-2 py-1 rounded-full bg-background-950/70 text-background-50 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4 flex flex-col justify-center">
                  <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #media */}
      <section id="media" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            精彩预告
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 max-w-md mx-auto">
            精选高清影视内容预览，发现你的下一部必看好片
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            {mediaItems.map((item) => (
              <div
                key={item.id}
                className="group cursor-pointer"
              >
                <div className="relative aspect-[2/3] rounded-xl overflow-hidden mb-3">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                    </div>
                  </div>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-500">{item.type}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-400">{item.dur}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #updates */}
      <section id="updates" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 max-w-md mx-auto">
            久久影视平台最新高清电视剧更新、高清电影入库及功能动态
          </p>
          <div className="max-w-3xl mx-auto">
            {updates.map((item, idx) => (
              <div key={item.id} className="flex gap-4">
                <div className="flex flex-col items-center flex-shrink-0">
                  <div className={`w-2.5 h-2.5 rounded-full mt-1.5 ${idx === 0 ? 'bg-accent-500 ring-4 ring-accent-100' : 'bg-background-300'}`}></div>
                  {idx < updates.length - 1 && (
                    <div className="w-px flex-1 bg-background-200 my-1"></div>
                  )}
                </div>
                <div className="pb-6">
                  <div className="flex items-center gap-3 flex-wrap mb-1">
                    <span className="text-xs font-mono text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className={`text-[10px] px-2 py-0.5 rounded-full ${item.tagColor} text-background-50 font-medium whitespace-nowrap`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}